import React, { useEffect, useRef } from "react";
import { CountUp } from "countup.js";

const AnimateAnggota = ({ targetNumber }) => {
  const countUpRef = useRef(null);
  const hasAnimated = useRef(false);

  useEffect(() => {
    const currentRef = countUpRef.current;

    const handleIntersection = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !hasAnimated.current) {
          const countUp = new CountUp(currentRef, targetNumber, {
            duration: 2,
            separator: ".",
          });
          if (!countUp.error) {
            countUp.start();
            hasAnimated.current = true;
            observer.unobserve(entry.target);
          } else {
            console.error(countUp.error);
          }
        }
      });
    };

    const observer = new IntersectionObserver(handleIntersection, {
      threshold: 0.1,
    });

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [targetNumber]);

  return (
    <div className="pb-5">
      <h3
        id="about-headline"
        className="text-center lg:text-left text-black text-2xl lg:text-5xl font-extrabold"
        ref={countUpRef}>
        0
      </h3>
    </div>
  );
};

export default AnimateAnggota;
